import config from 'src/config/index';

import DateEditor from '../../DateEditor';
import TextEditor from '../../TextEditor';
import AgHeader from './AgHeader';
import { GeneralFormat } from '../../GeneralFormat';

/** Column defs. */
export const columnDef = (checkEditable, onInsert) =>
  config.tables.getIn(['project', 'approval', 'columns']).map(column => {
    const field = column.get('field');

    if (field === 'dateReceived') {
      return column.merge({
        editable: checkEditable,
        cellRendererFramework: GeneralFormat,
        headerComponentFramework: AgHeader,
        sortable: true,
        cellEditorFramework: DateEditor,
      });
    }

    if (field === 'dateSent') {
      return column.merge({
        editable: checkEditable,
        cellRendererFramework: GeneralFormat,
        headerComponentFramework: AgHeader,
        sortable: true,
        cellEditorFramework: DateEditor,
      });
    }

    if (field === 'applistLabel') {
      return column.merge({
        editable: checkEditable,
        cellEditorFramework: TextEditor,
        headerComponentFramework: AgHeader,
        onClick: onInsert,
        sortable: true,
        cellRendererFramework: GeneralFormat,
        colSpan: params => (params.node.rowPinned ? 3 : 1),
      });
    }

    if (field === 'numberApproved') {
      return column.merge({
        headerComponentFramework: AgHeader,
        cellRendererFramework: GeneralFormat,
        headerTooltip: 'Approved% = #Approved / #Targets',
      });
    }

    if (field === 'numberOfContacted') {
      return column.merge({
        headerComponentFramework: AgHeader,
        cellRendererFramework: GeneralFormat,
        headerTooltip: 'Contacted% = #Contacted / #Approved',
      });
    }

    if (field === 'numberOfLeads') {
      return column.merge({
        headerComponentFramework: AgHeader,
        cellRendererFramework: GeneralFormat,
        headerTooltip: 'Leads% = #Leads / #Approved',
      });
    }

    if (field === 'numberOfCc') {
      return column.merge({
        headerComponentFramework: AgHeader,
        cellRendererFramework: GeneralFormat,
        headerTooltip: 'CC% = #CC / #Approved',
      });
    }

    if (field === 'numberOfVisit') {
      return column.merge({
        headerComponentFramework: AgHeader,
        cellRendererFramework: GeneralFormat,
        headerTooltip: 'Visit% = #Visit / #Approved',
      });
    }

    return column.merge({
      headerComponentFramework: AgHeader,
      sortable: true,
      cellRendererFramework: GeneralFormat,
    });
  });
